export default {
  DOMAINS: {
    BTINF: "BTINF",
    BTSUP: "BTSUP",
  },
};
